module.exports = __webpack_public_path__ + "icons/original/small/small-f5.72cc42d0d642b89a43f7d5dae38777d0.png";


//////////////////
// WEBPACK FOOTER
// ./src/web/icons/original/small/small-f5.png
// module id = MjYr
// module chunks = app